import CurrencyInputField, { type CurrencyInputProps } from "react-currency-input-field";
import { Input } from "../../../ui/input";
import { renderCurrencySymbol } from "../../../../utils/helpers/job";

export type MoneyInputProps = CurrencyInputProps & {
    currency?: string;
};

function MoneyInput({
    className,
    currency,
    prefix,
    decimalsLimit = 2,
    allowNegativeValue = false,
    ...props
}: MoneyInputProps) {
    return (
        <CurrencyInputField
            customInput={Input}
            className={className}
            prefix={prefix ?? renderCurrencySymbol(currency)}
            decimalsLimit={decimalsLimit}
            allowNegativeValue={allowNegativeValue}
            {...props}
        />
    );
}

export default MoneyInput;
